import LoggerWrapper from '../lib/LoggerWrapper';
import { GET_CURRENT_USER_SUCCESS, LOGIN_SUCCESS} from "../actions/actionTypes";

export default store => next => (action) => {
    if (action.type === LOGIN_SUCCESS) {
        LoggerWrapper.startNewSesstion();

        const { currentUser } = store.getState();
        if (currentUser) {
            const { userName, firstName, lastName } = currentUser;
            LoggerWrapper.identify(userName, firstName, lastName);
        }
    }

    if (action.type === GET_CURRENT_USER_SUCCESS) {
        const { userName, firstName, lastName } = action.response;
        LoggerWrapper.identify(userName, firstName, lastName);
    }

    return next(action);
};